import {randomKey} from 'common/src/utils/commonUtils';
import signal from 'common/src/utils/pubsub/signal';
import {Chat, ChatConfig} from '../copilot.types';
import agentSession from './creators/agentSession';
import formatCancellationSignalName from './formatCancellationSignalName';

export default function chat({type, agents, fallbackAgent, isPlanModeEnabled}: ChatConfig): Chat {
  const id = randomKey();
  const singleAgent = agents.length === 1 ? agents[0] : null;

  return {
    id,
    type,
    agents,
    fallbackAgent,
    isPlanModeEnabled,
    agentSession: singleAgent ? agentSession(singleAgent) : null,
    blackboard: {
      chatHistory: [],
      plan: null,
    },
    abortController: null,
    draftFiles: [],
    files: [],
    currentInteractionId: null,
    cancellationCompleteSignal: signal(formatCancellationSignalName(id)),
    blockingWidgetResolvers: null,
  };
}
